import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { getYear } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { ModalService } from '@rocketfinancialcorp/rocket-ui/modal';

import { PrivacyPolicyComponent, TermsConditionsComponent } from '@shared/components';
import { APP_ENV_CONFIG, BRAND_CONFIG } from '@shared/services';
import { systemTimeZone } from '@shared/utils';

// Relative, not via '@shared/components': that barrel re-exports this component's own folder, and
// the resulting cycle leaves AppVersionComponent undefined when the decorator runs.
import { AppVersionComponent } from '../../app-version/app-version.component';

@Component({
  selector: 'app-auth-layout-footer',
  templateUrl: './auth-layout-footer.component.html',
  styleUrls: ['./auth-layout-footer.component.scss'],
  imports: [AppVersionComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class AuthLayoutFooterComponent {
  @HostBinding('class.auth-footer') commonClass = true;

  brand = inject(BRAND_CONFIG);

  envConfig = inject(APP_ENV_CONFIG);

  get currentYear(): string {
    return `${getYear(toZonedTime(new Date(), systemTimeZone))}`;
  }

  constructor(private modalService: ModalService) {}

  onPrivacyPolicyClick() {
    this.modalService.open(PrivacyPolicyComponent, { className: 'auth-document-modal', size: 'full-size' });
  }

  onTermsConditionsClick() {
    this.modalService.open(TermsConditionsComponent, { className: 'auth-document-modal', size: 'full-size' });
  }
}
